import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgSelect } from "@intelligems/ig-theme";
import { PeriodType, PeriodTypeList } from "@intelligems/ig-types";
import { capitalizeFirstLetter } from "@intelligems/ig-utils";
import { MenuItem } from "@mui/material";

import { setSitewideDashboardFilter } from "../../../../store/slices/sitewideDashboardFilters";
import { IAppState } from "../../../../store/types/store";

export const AggregationSelect = () => {
  const dispatch = useDispatch();
  const sitewideDashboardFilters = useSelector(
    (state: IAppState) => state.sitewideDashboardFilters
  );

  return (
    <IgSelect
      size={"small"}
      onChange={(e) => {
        dispatch(
          setSitewideDashboardFilter({
            ...sitewideDashboardFilters,
            period: e.target.value as PeriodType,
          })
        );
      }}
      value={sitewideDashboardFilters.period ?? "hour"}
    >
      {PeriodTypeList.map((value) => (
        <MenuItem
          value={value}
          sx={{
            fontWeight: sitewideDashboardFilters.period === value ? 500 : 400,
          }}
          key={value}
        >
          {capitalizeFirstLetter(value === "day" ? "daily" : value + "ly")}
        </MenuItem>
      ))}
    </IgSelect>
  );
};
